<div [class.active]="isFilterSectionVisible" class="pcg-filter js-filter-content">
    <a (click)="onSkipToResults($event)" class="pcg-filter__skip-navigation" href="#search-results">Skip to results</a>
    <div class="pcg-filter__inner">
        <fieldset class="pcg-category">
            <legend class="pcg-category__title pcg-contrast__color-main">Category</legend>
            <ul class="pcg-category__list">
                <li *ngFor="let category of searchConfig.topLevelCategories">
                    <label class="pcg-custom-checkbox pcg-contrast-custom-checkbox">
                        <input (change)="categoryCheckboxChange($event)" [checked]="isCategoryChecked(category.directoryTemplateId)" type="checkbox" value="{{category.directoryTemplateId}}">
                        <span class="pcg-custom-checkbox__text">{{ category.title }}</span>
                    </label>
                </li>
            </ul>
        </fieldset>

        <fieldset class="pcg-postcode-search pcg-contrast-postcode-search">
            <legend class="pcg-postcode-search__title">Location</legend>
            <div class="pcg-postcode-search__row">
                <div class="pcg-postcode-search__wrapper">
                    <label class="visually-hidden" for="postcode-input">Postcode</label>
                    <input [formControl]="localPostcodeControl" class="pcg-postcode-search__input" id="postcode-input" placeholder="Postcode" type="text">
                </div>
                <div class="pcg-postcode-search__wrapper">
                    <label class="visually-hidden" for="distance-input">Select radius</label>
                    <select [formControl]="localDistanceControl" class="pcg-postcode-search__select" id="distance-input" name="">
                        <option value="1609">1 mile</option>
                        <option value="3218">3 miles</option>
                        <option value="4828">5 miles</option>
                        <option value="8046">10 miles</option>
                        <option value="16093">20 miles</option>
                    </select>
                </div>
            </div>

            <button (click)="onSearchButtonClicked($event)" class="pcg-postcode-search__btn" type="submit">Apply Location</button>
            <button (click)="onToggleMapButtonClicked($event)" [attr.aria-label]="isMapVisible ? 'Hide map' : 'Show map'" class="pcg-postcode-search__btn pcg-postcode-search__btn--map">{{ isMapVisible ? "Hide map" : "Show map" }}</button>
        </fieldset>

        <button (click)="onToggleFilterSection($event)" *ngIf="this.eventsCategoriesFacet" class="pcg-filter__mobile-btn pcg-contrast__btn js-filter-button" type="button">Filters <span *ngIf="GetSelectedFiltersCount() > 0" class="pcg-filter__counter pcg-contrast__color-alt">({{ GetSelectedFiltersCount() }})</span></button>

        <div *ngIf="this.eventsCategoriesFacet" [class.active]="isFilterSectionVisible" class="pcg-filter__content js-filter-content">
            <fieldset class="pcg-search-filter">
                <legend class="pcg-search-filter__title pcg-contrast__color-main">Filters <span *ngIf="GetSelectedFiltersCount() > 0" class="pcg-search-filter__counter pcg-contrast__color-alt">({{ GetSelectedFiltersCount() }})</span></legend>

                <pcg-ng-multiple-choice-facet
                    *ngIf="categoriesFacet.items?.length"
                    [aggregation]="eventsCategoriesFacet"
                    [allowMultipleChoice]="true"
                    [formControl]="searchForm.categories"
                    [searchConfig]="searchConfig">
                </pcg-ng-multiple-choice-facet>

            </fieldset>

            <button (click)="onResetButtonClicked($event)" *ngIf="expandedCategoryIds.length > 0 || (postcodeControl.value != null && postcodeControl.value !== '')" class="pcg-filter__reset pcg-contrast__btn">Reset filters</button>
        </div>
    </div>
</div>
